
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import './pendo-button.js';
import './collapse-transition-mixin.js';
import 'v-tooltip';
import './tooltip-mixin.js';
import PendoTooltip from './pendo-tooltip.js';
import './pendo-divider.js';
import 'element-ui/lib/checkbox';
import PendoCheckbox from './pendo-checkbox.js';
import 'lodash/uniqueId';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import 'popper.js';
import 'uuid';
import 'vue-resize';
import 'lodash/clamp';
import './picker-popover-mixin.js';
import 'lodash/isPlainObject';
import 'lodash/debounce';
import './pendo-empty-state.js';
import './emitter-mixin.js';
import 'element-ui/lib/dialog';
import 'resize-observer-polyfill';
import './pendo-modal.js';
import 'lodash/isFunction';
import './multiselect-helper-mixin.js';
import './pendo-multiselect-props.js';
import './pendo-multiselect-core.js';
import './pendo-multiselect-input.js';
import './pendo-multiselect-option.js';
import 'compute-scroll-into-view';
import './pendo-multiselect-options.js';
import './pendo-multiselect-trigger.js';
import './pendo-multiselect-value.js';
import './pendo-multiselect.js';
import './pendo-icon-button.js';
import './pendo-responsive.js';
import 'lodash/cloneDeep';
import 'lodash/keyBy';
import 'scrollparent';
import 'vue-observe-visibility';
import PendoTable from './pendo-table.js';
import './pendo-checkbox-cell.js';
import '@shopify/draggable/lib/es5/sortable.js';
import './pendo-draggable.js';
import './pendo-column-reorder.js';
import './pendo-column-chooser.js';
import 'lodash/groupBy';
import PendoStatusOverlay from './pendo-status-overlay.js';
import PendoGuideElementTypeAction from './pendo-guide-element-type-action.js';

var script = {
  name: 'PendoGuideElementsTable',
  components: {
    PendoGuideElementTypeAction,
    PendoCheckbox,
    PendoTable,
    PendoStatusOverlay
  },
  directives: {
    PendoTooltip
  },
  props: {
    guideStepNames: {
      type: Array,
      required: true
    },
    elementsActivityAggStatus: {
      type: String,
      required: true
    },
    loadingOptions: {
      type: Object,
      default: () => {}
    },
    elementsActivity: {
      type: Array,
      required: true
    },
    elementsTableColumns: {
      type: Array,
      required: true
    },
    csvDownloadConfig: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      overflowTooltipContent: null,
      groupByStep: true,
      showDeleted: false
    };
  },

  computed: {
    filters() {
      return [{
        value: this.showDeleted,
        filterFn: row => this.showDeleted || !row.isDeleted
      }];
    }

  },
  watch: {
    groupByStep(newVal) {
      this.$emit('toggle-group-by-step', newVal);
    },

    showDeleted(newVal) {
      this.$emit('toggle-show-deleted', newVal);
    }

  },
  methods: {
    checkForOverflowingContent(event, row) {
      this.overflowTooltipContent = null;
      const _event$target = event.target,
            scrollWidth = _event$target.scrollWidth,
            clientWidth = _event$target.clientWidth;

      if (scrollWidth > clientWidth) {
        const tooltipText = this.getGroupByStepHeaderText(row);
        this.overflowTooltipContent = tooltipText;
      }
    },

    getElementActions(uiElementActions) {
      if (!uiElementActions) {
        return [];
      }

      const elementActions = uiElementActions.map(({
        action,
        icon
      }) => ({
        name: action,
        icon
      }));
      return elementActions;
    },

    getGroupByStepHeaderText({
      guideStepId
    }) {
      const stepIndex = this.guideStepNames.findIndex(step => step.id === guideStepId) + 1;

      if (stepIndex === 0) {
        return 'Deleted Step';
      }

      const _this$guideStepNames$ = this.guideStepNames.find(step => step.id === guideStepId),
            stepName = _this$guideStepNames$.name;

      if (stepName) {
        return `Step ${stepIndex} - ${stepName}`;
      }

      return `Step ${stepIndex}`;
    },

    getRowClassName({
      row
    }) {
      if (row.isDeleted) {
        return 'is-deleted';
      }

      return;
    },

    onMetricClick({
      row
    }) {
      this.$emit('on-metric-click', row);
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-guide-elements"
  }, [_c('pendo-table', {
    staticClass: "pendo-guide-elements-table",
    attrs: {
      "data": _vm.elementsActivity,
      "columns": _vm.elementsTableColumns,
      "filters": _vm.filters,
      "height": 600,
      "row-key": "uiElementId",
      "csv-config": _vm.csvDownloadConfig,
      "csv-download": "",
      "row-class-name": _vm.getRowClassName,
      "default-sort": {
        prop: 'uiElementName',
        order: 'ascending'
      },
      "group-config": {
        enabled: _vm.groupByStep,
        groupKey: 'guideStepId',
        sortChildren: true
      }
    },
    on: {
      "link-click": _vm.onMetricClick
    },
    scopedSlots: _vm._u([{
      key: "headerLeft",
      fn: function () {
        return [_vm._v("\n            Guide Elements\n        ")];
      },
      proxy: true
    }, {
      key: "groupRow",
      fn: function (ref) {
        var row = ref.row;
        return [_c('div', {
          staticClass: "pendo-guide-elements-table__group-by-step-header"
        }, [_c('div', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              content: _vm.overflowTooltipContent,
              delay: {
                show: 300,
                hide: 0
              },
              arrow: true,
              multiline: true,
              boundariesElement: 'body'
            },
            expression: "{\n                        content: overflowTooltipContent,\n                        delay: { show: 300, hide: 0 },\n                        arrow: true,\n                        multiline: true,\n                        boundariesElement: 'body'\n                    }"
          }],
          staticClass: "pendo-guide-elements-table__group-by-step-header__group-header__step-name",
          on: {
            "mouseenter": function ($event) {
              return _vm.checkForOverflowingContent($event, row);
            }
          }
        }, [_vm._v("\n                    " + _vm._s(_vm.getGroupByStepHeaderText(row)) + "\n                ")])])];
      }
    }, {
      key: "status",
      fn: function () {
        return [_c('pendo-status-overlay', {
          attrs: {
            "state": _vm.elementsActivityAggStatus,
            "options": _vm.loadingOptions
          }
        })];
      },
      proxy: true
    }, {
      key: "headerActions",
      fn: function () {
        return [_c('div', {
          staticClass: "pendo-guide-elements-table__header-actions"
        }, [_c('pendo-checkbox', {
          staticClass: "show-deleted-elements",
          attrs: {
            "label": "Show Deleted Elements"
          },
          model: {
            value: _vm.showDeleted,
            callback: function ($$v) {
              _vm.showDeleted = $$v;
            },
            expression: "showDeleted"
          }
        }), _vm._v(" "), _c('pendo-checkbox', {
          staticClass: "group-by-step",
          attrs: {
            "label": "Group By Step"
          },
          model: {
            value: _vm.groupByStep,
            callback: function ($$v) {
              _vm.groupByStep = $$v;
            },
            expression: "groupByStep"
          }
        })], 1)];
      },
      proxy: true
    }, {
      key: "uiElementText",
      fn: function (ref) {
        var ref_row = ref.row;
        var uiElementText = ref_row.uiElementText;
        var isDeleted = ref_row.isDeleted;
        return [_c('div', {
          staticClass: "pendo-guide-elements-table__element-text"
        }, [_vm._v("\n                " + _vm._s(uiElementText) + "\n                "), isDeleted ? _c('span', {
          staticClass: "pendo-guide-elements-table__element-text__deleted-label"
        }, [_vm._v("\n                    Deleted\n                ")]) : _vm._e()])];
      }
    }, {
      key: "guideStepName",
      fn: function (ref) {
        var guideStepName = ref.row.guideStepName;
        return [_c('div', {
          staticClass: "pendo-guide-elements-table__step-name",
          class: {
            'is-unnamed': guideStepName.includes('Unnamed'),
            'is-deleted': guideStepName.includes('Deleted')
          }
        }, [_vm._v("\n                " + _vm._s(guideStepName) + "\n            ")])];
      }
    }, {
      key: "uiElementType",
      fn: function (ref) {
        var ref_row = ref.row;
        var uiElementType = ref_row.uiElementType;
        var uiElementTypeIcon = ref_row.uiElementTypeIcon;
        return [_c('pendo-guide-element-type-action', {
          attrs: {
            "ui-elements": [{
              name: uiElementType,
              icon: uiElementTypeIcon
            }]
          }
        })];
      }
    }, {
      key: "uiElementActions",
      fn: function (ref) {
        var uiElementActions = ref.row.uiElementActions;
        return [_c('pendo-guide-element-type-action', {
          attrs: {
            "ui-elements": _vm.getElementActions(uiElementActions)
          }
        })];
      }
    }])
  })], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-guide-elements-table.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoGuideElementsTable = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoGuideElementsTable;
